"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _StandardIconWrapper = _interopRequireDefault(require("./StandardIconWrapper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var CPUIcon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(CPUIcon, _React$PureComponent);

  function CPUIcon() {
    _classCallCheck(this, CPUIcon);

    return _possibleConstructorReturn(this, _getPrototypeOf(CPUIcon).apply(this, arguments));
  }

  _createClass(CPUIcon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          color = _this$props.color,
          className = _this$props.className,
          props = _objectWithoutProperties(_this$props, ["color", "className"]);
      /* eslint-disable max-len */


      return _react.default.createElement(_StandardIconWrapper.default, _extends({
        className: (0, _classnames.default)(className, 'cpu-icon')
      }, props), _react.default.createElement("g", null, _react.default.createElement("path", {
        fill: color,
        d: "M7.4941,7.9888 L4.5101,7.9888 C4.2331,7.9888 4.0101,7.7648 4.0101,7.4888 L4.0101,4.5038 C4.0101,4.2278 4.2331,4.0038 4.5101,4.0038 L7.4941,4.0038 C7.7701,4.0038 7.9941,4.2278 7.9941,4.5038 L7.9941,7.4888 C7.9941,7.7648 7.7701,7.9888 7.4941,7.9888"
      }), _react.default.createElement("path", {
        fill: color,
        d: "M11.25,7.252 C11.664,7.252 12,7.588 12,8.002 C12,8.416 11.664,8.752 11.25,8.752 L10.476,8.752 C10.36,9.652 9.652,10.357 8.752,10.471 L8.752,11.25 C8.752,11.664 8.415,12 8.002,12 C7.588,12 7.252,11.664 7.252,11.25 L7.252,10.496 L4.748,10.496 L4.748,11.25 C4.748,11.664 4.412,12 3.998,12 C3.584,12 3.248,11.664 3.248,11.25 L3.248,10.471 C2.35,10.355 1.644,9.65 1.528,8.752 L0.75,8.752 C0.336,8.752 0,8.416 0,8.002 C0,7.588 0.336,7.252 0.75,7.252 L1.502,7.252 L1.502,4.748 L0.75,4.748 C0.336,4.748 0,4.412 0,3.998 C0,3.584 0.336,3.248 0.75,3.248 L1.527,3.248 C1.64,2.346 2.347,1.637 3.248,1.522 L3.248,0.75 C3.248,0.336 3.584,0 3.998,0 C4.412,0 4.748,0.336 4.748,0.75 L4.748,1.496 L7.252,1.496 L7.252,0.75 C7.252,0.336 7.588,0 8.002,0 C8.415,0 8.752,0.336 8.752,0.75 L8.752,1.521 C9.655,1.635 10.364,2.345 10.477,3.248 L11.25,3.248 C11.664,3.248 12,3.584 12,3.998 C12,4.412 11.664,4.748 11.25,4.748 L10.502,4.748 L10.502,7.252 L11.25,7.252 Z M7.996,9 C8.548,9 8.996,8.552 8.996,8 L8.996,4.004 C8.996,3.452 8.548,3.004 7.996,3.004 L4,3.004 C3.448,3.004 3,3.452 3,4.004 L3,8 C3,8.552 3.448,9 4,9 L7.996,9 Z"
      })));
      /* eslint-enable max-len */
    }
  }]);

  return CPUIcon;
}(_react.default.PureComponent);

exports.default = CPUIcon;
CPUIcon.defaultProps = {
  color: 'inherit'
};
CPUIcon.propTypes = {
  className: _propTypes.default.string,
  color: _propTypes.default.string
};